import { Observable } from 'rxjs';
import { ActionFilter } from '../types/action-filter.type';
import { filter } from 'rxjs/operators';

/**
 * Filters actions on the source observable based on the provided action filter.
 * If the action filter is false, no filtering will occur.
 *
 * @param actionFilter Optional callback function which returns true if the action should be included
 */
export function filterActions<TActionProps>(actionFilter: ActionFilter<TActionProps>) {
  return (source$: Observable<TActionProps>) =>
    source$.pipe(filter((actionProps) => !actionFilter || actionFilter(actionProps)));
}
